import React, { Component, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { GlgRoundedButtonIcon, GlgSelect, GlgTooltip } from 'SharedComponents'
import { NotificationManager } from 'react-notifications'
import Checkbox from './event_setup/checkbox'
import CalendarCustomInput from './event_setup/calendar_custom_input'
import SingleCriteriaOptions from './event_setup/single_criteria_options'
import DivisionsFlightsTable from './event_setup/divisions_flights_table'
import MultipleCriteriaTable from './event_setup/multiple_criteria_table'

const internationalize = (...args) => !window.I18n ? '' : window.I18n.t(...args)


const renderDivision = (division, inSet, props) => (
  <li key={division.id} className='division_container'>
    <div className={!inSet ? 'flex' : ''}>
      <label className='division_name'>{ division.name }</label>
      <span className='summary'>
        {
          division.summary.map((data, i) =>
            <>
              { i > 0 && <strong>{' | '}</strong> }
              <strong>{ data }</strong>
            </>
          )
        }
      </span>
      {division.boundaries && (
        <span>
          {' | ' + division.boundaries}
        </span>
      )}
      {!inSet && 
        <a 
          className={division.name === 'All Golfers' ? 'right disabled' : 'right'}
           onClick={() => {
            if (window.confirm( internationalize(('divisions.index.confirm_delete'), {name: division.name}) )) {
              props.removeDivision(division.id)
            }
           }}
        > 
          {props.content.links.delete_divisions.name}
        </a>
      }
    </div>
  </li>
)

class DivisionsOverview extends Component {
  constructor(props){
    super(props)
  }

  componentDidMount() {
    window.NotificationManager = NotificationManager
  }

  render() {
    const divisionsWithoutDivisionset = this.props.content.divisions_without_divisionset
    const { divisionsets } = this.props.content

    return (
      <>
        <li className='add-division-button-container'>
          <GlgRoundedButtonIcon
            text={ internationalize('divisions.index.form_division.add_new_divisions') }
            icon={ 'gga-circle-plus' }
            onClick={ () => { this.props.setData([ 'addingDivision' ], true) }}
          />
        </li>
        { divisionsWithoutDivisionset.map(division => renderDivision(division, false, this.props)) }
        {
          divisionsets.map(divisionset => (
            <li key={divisionset.id} className='division_container'>
              <div className='divisionset_name flex'>
                { divisionset.name }
                <a 
                  className='right' 
                  onClick={() => {
                    if (window.confirm( internationalize(('divisions.index.confirm_delete'), {name: divisionset.name}) )) {
                      this.props.removeDivisionset(divisionset.id)
                    }
                  }}
                >
                  {this.props.content.links.delete_divisionsets.name}
                </a> 
              </div>
              <ul className='divisionset_divisions'> { divisionset.divisions.map(division => renderDivision(division, true, this.props)) } </ul>
            </li>
          ))
        }
      </>
    )
  }
}

const GolfersDivisionsCount = (props) => {
  const golfersDivisions = props.content.create_division.golfers_divisions
  const selectedHandicap = props.content.create_division.criteria.selected_handicap

  useEffect(() => {
    // compute division count errors
    const error = (parseInt(golfersDivisions.choices[golfersDivisions.selected].value) || 0 > 0) ? undefined : (
      golfersDivisions.selected === 'number_of_golfers' ? internationalize('divisions.number_golfers_per_division') : internationalize('divisions.number_of_division')
    )
    props.setError(GolfersDivisionsCount.name, error)

    return () => {
      // on unmount, retract errors
      props.setError(GolfersDivisionsCount.name, undefined)
    }
  }, [ golfersDivisions.selected, golfersDivisions.choices[golfersDivisions.selected].value ])

  const selectCountType = (countType) => {
    props.setData([ 'create_division', 'golfers_divisions', 'selected' ], countType)
  }
  const setCount = (value) => {
    const countType = golfersDivisions.selected
    props.setData([ 'create_division', 'golfers_divisions', 'choices', countType, 'value' ], value)
    if (countType === 'number_of_golfers') {
      (props.content.create_division.divisions || []).forEach((_, i) => {
        props.setData([ 'create_division', 'divisions', i, 'golfers_per_division' ], value)
      })
    }
  }


  return (
    <div className='radio-option golfers_divisions_count'>
      <div className='options-container vertical'>
        {
          Object.keys(golfersDivisions.choices).map((choiceKey, index) => {
            const choice = golfersDivisions.choices[choiceKey]
            return (
              <div className='grid' key={`golfers_divisions_${index}`}>
                <label className={`icheck-label ${choice.enabled ? '' : 'disabled'}`} htmlFor={`golfers_divisions_${index}`}>
                  <div className={`iradio_square-orange icheck-item ${choice.enabled ? '' : 'disabled'} ${choiceKey === golfersDivisions.selected ? 'checked' : ''}`}>
                    <input
                      id={`golfers_divisions_${index}`}
                      className='i-checks icheck-input'
                      type='radio'
                      name={`golfers_divisions_${index}`}
                      value={choiceKey}
                      onChange={ event => choice.enabled && selectCountType(event.target.value) }
                      checked={choiceKey === golfersDivisions.selected}
                      disabled={! choice.enabled}
                    />
                  </div>
                  <span>{choice.label}</span>
                </label>
                <input
                  className={`form-control ${choiceKey === golfersDivisions.selected ? '' : 'disabled'}`}
                  value={ choice.value }
                  onChange={ e => setCount(e.target.value) }
                  onBlur={ e => {
                    const count = Math.max(0, parseInt(e.target.value) || 0)
                    setCount(count)
                  }}
                  disabled={ choiceKey !== golfersDivisions.selected }
                />
              </div>
            )
          })
        }
        {
          golfersDivisions.selected === 'number_of_divisions' &&
            <>
              <Checkbox
                key='auto_fill'
                label={golfersDivisions.auto_fill.label}
                selected={golfersDivisions.auto_fill.selected}
                setOption={(v) => { props.setData( [ 'create_division', 'golfers_divisions', 'auto_fill', 'selected' ], v) }}
              />
              <Checkbox
                key='maximum_handicap'
                label={selectedHandicap === 'combined_index_usga_index' ? golfersDivisions.maximum_handicap.label_handicap_index : golfersDivisions.maximum_handicap.label_playing_handicap}
                selected={golfersDivisions.maximum_handicap.selected}
                setOption={(v) => { props.setData( [ 'create_division', 'golfers_divisions', 'maximum_handicap', 'selected' ], v) }}
              />
            </>
            
        }
      </div>
    </div>
  )
}

class CreateDivision extends Component {
  constructor(props){
    super(props)
    this.state = {
      isDropdownOpen: false,
      dropdownPosition: { top: 0, left: 0 }
    }
    this.dropdownRef = React.createRef()
    this.checkboxRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick)
    window.addEventListener('scroll', this.handleScroll, true)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick)
    window.removeEventListener('scroll', this.handleScroll, true)
  }

  handleOutsideClick = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target) && !this.checkboxRef.current.contains(event.target)) {
      this.setState({ isDropdownOpen: false })
    }
  }

  handleScroll = () => {
    this.setState({isDropdownOpen: false})
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }), this.updateDropdownPosition)
  }

  updateDropdownPosition = () => {
    if (this.dropdownRef.current) {
      const rect = this.dropdownRef.current.getBoundingClientRect()
      this.setState({
        dropdownPosition: {
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
        }
      })
    }
  }

  render() {
    const getDateFormat = format => {
      if (format === 'YMD')
        return 'yyyy/MM/dd h:mm aa'
      else if (format === 'DMY')
        return 'dd/MM/yyyy h:mm aa'
      else
        return 'MM/dd/yyyy h:mm aa'
    }

    const getSelectedCriteria = () => {
      if (Array.isArray(criteria.selected)) {
        if (criteria.selected.length === 1) {
          const value = criteria.selected[0]
          return (value === 'by_gender' || value === 'by_age') ? 'by_multiple_criteria' : value
        } else if (criteria.selected.length === 0) {
          return ''
        }
        return 'by_multiple_criteria'
      }
      return  criteria.selected || ''
    }

    const modalOpened = this.props.content.modal_opened
    const criteria = this.props.content.create_division.criteria
    const selectedCriteria = getSelectedCriteria()
    const autofillOptions = this.props.content.create_division.autofill_options.choices
    const autofill = this.props.content.create_division.autofill_options.selected
    const { isDropdownOpen, dropdownPosition } = this.state
    const customFields = this.props.content.create_division.custom_fields
    const customFieldAnswers = this.props.content.create_division.custom_field_answers
    const selectedCustomField = this.props.content.create_division.custom_fields.selected
    const divisionSource = this.props.content.create_division.division_source
    const eventDivisions = this.props.content.create_division.copy_event_divisions
    const roundDivisions = this.props.content.create_division.copy_round_divisions
    const rounds = this.props.content.create_division.rounds
    const selectedRound = this.props.content.create_division.rounds.selected
    const roundUsedCourses = this.props.content.create_division.round_used_courses
    const divisionsByCourse = this.props.content.create_division.divisions_by_course || {}
    const dateForAge = this.props.content.create_division.date_for_age
    const dateFormat = getDateFormat(this.props.content.create_division.date_format)
    const genderAnswers = this.props.content.create_division.gender_answers
    const availableMembersCount = this.props.content.create_division.available_members_count
    const divisionStartIndex = this.props.content.create_division.golfers_divisions.start_index
    const tees = this.props.content.create_division.tees || {}
    const golfersPerDivision = this.props.content.create_division.golfers_divisions.choices.number_of_golfers.value
    const numberOfDivisions = this.props.content.create_division.golfers_divisions.choices.number_of_divisions.value
    const divisions = this.props.content.create_division.divisions || []
    const multipleCriteriaDivisions = this.props.content.create_division.multiple_criteria_divisions || []
    const indexes = this.props.content.create_division.available_members_index || []
    const byGolfersOrDivisionsCount = this.props.content.create_division.golfers_divisions.selected
    const byHandicap = selectedCriteria === 'by_handicap'
    const selectedHandicap = this.props.content.create_division.criteria.selected_handicap
    const handicapLabel = this.props.content.create_division.criteria.handicap_label
    const golferLabel = this.props.content.create_division.golfer_label

    const selectedTee = this.props.content.create_division.default_tee_and_hole?.tee
    const holeType = this.props.content.create_division.default_tee_and_hole?.hole
    const defaultTee =  this.props.content.create_division.default_tee_and_hole?.virtual_id

    const setDivisionData = (keys, value) => { this.props.setData([ 'create_division', 'divisions' ].concat(keys), value) }
    const setIndex = (value) => { this.props.setData([ 'create_division', 'available_members_index' ], value) }
    const setCount = (value) => {
      const golfersDivisions = this.props.content.create_division.golfers_divisions
  
      const countType = golfersDivisions.selected
      this.props.setData([ 'create_division', 'golfers_divisions', 'choices', countType, 'value' ], value)
      if (countType === 'number_of_golfers') {
        (this.props.content.create_division.divisions || []).forEach((_, i) => {
          this.props.setData([ 'create_division', 'divisions', i, 'golfers_per_division' ], value)
        })
      }
    }

    const handleSingleChange = (value) => {
      this.props.setData([ 'create_division', 'criteria', 'selected' ], value)
      this.props.setData([ 'create_division', 'criteria', 'selected_handicap' ], null)
      this.props.setData([ 'create_division', 'rounds', 'selected'], null)
    }

    const handleMultipleChange = (value) => {
      const newSelected = Array.isArray(criteria.selected) ? [...criteria.selected] : []
      if (newSelected.includes(value)) {
        newSelected.splice(newSelected.indexOf(value), 1)
      } else {
        newSelected.push(value)
      }
      this.props.setData(['create_division', 'criteria', 'selected'], newSelected)
    }

    const handleHandicapChange = (value, label) => {
      const newSelected = Array.isArray(criteria.selected) ? [...criteria.selected] : []
      if (criteria.selected_handicap === value) {
        this.props.setData(['create_division', 'criteria', 'selected_handicap'], null)
        this.props.setData(['create_division', 'criteria', 'handicap_label'], null)
        if (newSelected.includes('by_handicap')) {
          newSelected.splice(newSelected.indexOf('by_handicap'), 1)
        }
      } else {
        this.props.setData(['create_division', 'criteria', 'selected_handicap'], value)
        this.props.setData(['create_division', 'criteria', 'handicap_label'], label)
        if (!newSelected.includes('by_handicap')) {
          newSelected.push('by_handicap')
        }
      }
      this.props.setData(['create_division', 'criteria', 'selected'], newSelected)
      this.setState({ isDropdownOpen: false })
    }

    return (
      <div className='add_division_container'>
        <h4 className='divisions-title'>{ internationalize('divisions.index.form_division.add_new_divisions') }</h4>
        <label className='divisions-label'><b>{ internationalize('divisions.index.form_division.create_divisions') }</b></label>
        <div className='chips-container'>
          <div className='multiple-selection-box'>
            <div className='chips-top'>
              <label><b>{ internationalize('divisions.index.add_new_division_or_refill.multiple_selection') }</b></label>
            </div>

            <div className='chips-box'>
              {
                criteria.choices.multiple_criteria.map((choice) => (
                  choice.value === 'by_handicap' ? (
                    <div ref={this.dropdownRef}>
                      <div className='handicap-checkbox' ref={this.checkboxRef}>
                        <label key={`criteria_${choice.value}`} className={`chip ${choice.enabled ? '' : 'disabled '}${criteria.selected && criteria.selected.includes(choice.value) ? 'chip-checked' : ''}`} htmlFor={`criteria_${choice.value}`}>
                          <div className={`icheckbox_square-orange icheck-item ${choice.enabled ? '' : 'disabled '}${criteria.selected && criteria.selected.includes(choice.value) ? 'checked' : ''}`}>
                            <input
                              id={`criteria_${choice.value}`}
                              className='icheck-input'
                              type='checkbox'
                              name={`criteria_${choice.value}`}
                              value={choice.value}
                              onChange={() => this.toggleDropdown()}
                              checked={criteria.selected && criteria.selected.includes(choice.value)}
                              disabled={!choice.enabled}
                              readOnly
                            />
                          </div>
                          <span>{handicapLabel || choice.label}</span>
                          <span className='arrow-select'>{isDropdownOpen ? "▲" : "▼"}</span>
                        </label>
                      </div>

                      { isDropdownOpen && (
                         <div
                          className='handicap-dropdown'
                          style={{
                            position: 'absolute', 
                            top: `${dropdownPosition.top}px`, 
                            left: `${dropdownPosition.left}px`, 
                            width: '205px', 
                            backgroundColor: 'white', 
                            border: '1px solid #ccc', 
                            borderRadius: '5px', 
                            padding: '10px',
                            zIndex: 1000
                          }}
                          > 
                            <label className='dropdown-label'>{ internationalize('divisions.index.add_new_division_or_refill.select_one') }</label>
                            { choice.handicaps.map((handicap) => (
                              <label key={`criteria_${handicap.value}`} className={`chip ${handicap.enabled ? '' : 'disabled '}${criteria.selected_handicap && criteria.selected_handicap === handicap.value? 'chip-checked' : ''}`} htmlFor={`criteria_${handicap.value}`}>
                                <input
                                  id={`criteria_${handicap.value}`}
                                  className='no-radio'
                                  type='radio'
                                  name={`criteria_${handicap.value}`}
                                  value={handicap.value}
                                  onClick={event => handicap.enabled && handleHandicapChange(event.target.value, handicap.label)}
                                  checked={criteria.selected_handicap && criteria.selected_handicap === handicap.value}
                                  disabled={!handicap.enabled}
                                />
                                <span>{handicap.label}</span>
                              </label>
                            ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      <label key={`criteria_${choice.value}`} className={`chip ${choice.enabled ? '' : 'disabled '}${criteria.selected && criteria.selected.includes(choice.value) ? 'chip-checked' : ''}`} htmlFor={`criteria_${choice.value}`}>
                        <div className={`icheckbox_square-orange icheck-item ${choice.enabled ? '' : 'disabled '}${criteria.selected && criteria.selected.includes(choice.value) ? 'checked' : ''}`}>
                          <input
                            id={`criteria_${choice.value}`}
                            className='icheck-input'
                            type='checkbox'
                            name={`criteria_${choice.value}`}
                            value={choice.value}
                            onChange={ event => choice.enabled && handleMultipleChange(event.target.value) }
                            checked={criteria.selected && criteria.selected.includes(choice.value)}
                            disabled={!choice.enabled}
                          />
                        </div>
                        <span>{choice.label}</span>
                      </label>
                    </div>
                  )
                ))
              }
            </div>
          </div>

          <div className='single-selection-box'>
            <div className='chips-top'>
              <label><b>{ internationalize('divisions.index.add_new_division_or_refill.single_selection') }</b></label>
            </div>

            <div className='chips-box'>
              {
                criteria.choices.single_criteria.map((choice) =>
                  <div>
                    <label key={`criteria_${choice.value}`} className={`chip ${choice.enabled ? '' : 'disabled '}${choice.value === selectedCriteria ? 'chip-checked' : ''}`} htmlFor={`criteria_${choice.value}`}>
                      <input
                        id={`criteria_${choice.value}`}
                        className='no-radio'
                        type='radio'
                        name={`criteria_${choice.value}`}
                        value={choice.value}
                        onChange={ event => choice.enabled && handleSingleChange(event.target.value) }
                        checked={selectedCriteria === choice.value}
                        disabled={!choice.enabled}
                      />
                      <span>{choice.label}</span>
                    </label>
                  </div>
                )
              }
            </div>
          </div>
        </div>

        {
          <div className='division_options'>
            { byHandicap && <GolfersDivisionsCount {...this.props} /> }
            { !Array.isArray(criteria.selected) &&
              <SingleCriteriaOptions
                selectedCriteria={selectedCriteria}
                divisionSource={divisionSource}
                eventDivisions={eventDivisions}
                roundDivisions={roundDivisions}
                rounds={rounds}
                selectedRound={selectedRound}
                roundUsedCourses={roundUsedCourses}
                divisionsByCourse={divisionsByCourse}
                setData={this.props.setData}
              />
            }
            { selectedCriteria === 'by_custom_field' &&
              <div>
                <div className='btsp_horizontal_dotted_line'/>
                <div className='col-xs-12 add-margin-top-15 no-padding'>
                  <div className='select_custom_field col-xs-12 col-sm-5 col-md-4 col-lg-3 no-padding'>
                    <label>{ internationalize('divisions.index.add_new_division_or_refill.choose_custom_field') }</label>
                    <GlgSelect
                      key='select_custom_field'
                      items={ customFields.choices }
                      placeholder={ internationalize('divisions.index.add_new_division_or_refill.choose_custom_field') }
                      value={ customFields.selected }
                      noPreFill={true}
                      usePortal={true}
                      onChange={ value => { this.props.setData([ 'create_division', 'custom_fields', 'selected' ], value) }}
                    />
                  </div>
                </div>
                { selectedCustomField && customFieldAnswers[selectedCustomField] &&
                  <div className='col-xs-12 col-sm-6 col-md-5 col-lg-4 add-margin-top-10 no-padding'>
                    <div className='table-responsive btsp_table_container'>
                      <table className='divisions_by_custom_field_table table with_striping tables_v2 table-striped btsp_table'>
                        <thead>
                          <tr>
                            <th>{ internationalize('divisions.index.by_multiple_criteria.division_name') }</th>
                            <th>{ internationalize('divisions.index.by_multiple_criteria.total') }</th>
                          </tr>
                        </thead>
                        <tbody>
                          { customFieldAnswers[selectedCustomField].answers?.map((answer, index) => {
                              const golfers = customFieldAnswers[selectedCustomField].no_golfers?.[answer] || 0
                              return (
                                <tr key={`${answer}_${index}`}>
                                  <td>
                                    <input
                                      type='text'
                                      className='form-control division-name'
                                      defaultValue={`${answer} Division`}
                                    />
                                  </td>
                                  <td>{golfers} { golfers === 1 ? golferLabel.one : golferLabel.other }</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                }
              </div>
            }
            { byHandicap &&
              <DivisionsFlightsTable
                category='division'
                withIndexUpTo={byHandicap && byGolfersOrDivisionsCount === 'number_of_divisions' && this.props.content.create_division.golfers_divisions.maximum_handicap.selected}
                withNumberOfGolfers={byHandicap && byGolfersOrDivisionsCount === 'number_of_golfers'}
                withGenders={false}
                withAgeRange={false}
                fixedItems={{
                  type: byHandicap ? (byGolfersOrDivisionsCount === 'number_of_divisions' ? 'fixed' : 'max_golfers') : 'disabled',
                  total: availableMembersCount,
                  startIndex: divisionStartIndex,
                  value: parseInt(byGolfersOrDivisionsCount === 'number_of_divisions' ? numberOfDivisions : golfersPerDivision) || 0,
                  dependencies: [ this.props.content.create_division.golfers_divisions, selectedHandicap ],
                }}
                genderAnswers={genderAnswers}
                tees={tees}
                items={divisions}
                setItemData={setDivisionData}
                setError={this.props.setError}
                errorCheckingDependencies={[ selectedHandicap, this.props.content.create_division.divisions, this.props.content.create_division.golfers_divisions ]}
                rowClass={selectedHandicap}
                indexes={indexes}
                setIndex={setIndex}
                setCount={setCount}
                golfersDivisionsFlights={this.props.content.create_division.golfers_divisions}
              />
            }
            { selectedCriteria === 'by_multiple_criteria' &&
              
              <>
                { selectedHandicap === 'by_playing_handicap' &&
                  <div className='col-xs-12 no-padding'>
                    <div className='btsp_horizontal_dotted_line'/>
                    <div className='col-xs-12 col-lg-8 add-margin-top-20 no-padding'>
                      <div className='course-and-tees col-xs-12 col-sm-6 add-margin-right-30 no-padding'>
                        <div className='col-xs-12 add-margin-bottom-10 no-padding'>
                          <label>{ internationalize('divisions.index.by_course_handicap.set_course_and_default_tee') }</label>
                        </div>
                        <div className='col-xs-12 add-margin-bottom-10 no-padding'>
                          <GlgSelect
                            key='default_tee'
                            items={ Object.values(tees) }
                            placeholder={ internationalize('divisions.index.by_course_handicap.select_tee_required') }
                            value={ selectedTee }
                            noPreFill={true}
                            usePortal={true}
                            searchable={true}
                            height={38}
                            onChange={ v => {
                              const hash = {
                                tee: v,
                                hole: Object.values(tees[v].holes)[0]?.value || '',
                                virtual_id: Object.values(tees[v].holes)[0]?.virtual_id || '',
                              }
                              this.props.setData([ 'create_division', 'default_tee_and_hole' ], hash)
                            }}
                          />
                        </div>
                        <div className='col-xs-12 add-margin-bottom-10 no-padding'>
                          <GlgSelect
                            key='default_hole_type'
                            items={ selectedTee ? Object.values(tees[selectedTee].holes) : [] }
                            placeholder={ internationalize('divisions.index.by_course_handicap.prompt_all_front_back') }
                            value={ holeType }
                            noPreFill={true}
                            usePortal={true}
                            onChange={ v => {
                              const hash = {
                                tee: selectedTee,
                                hole: v,
                                virtual_id: tees[selectedTee]?.holes[v]?.virtual_id || '',
                              }
                              this.props.setData([ 'create_division', 'default_tee_and_hole' ], hash) }
                            }
                          />
                        </div>
                      </div>
                      <div className='handicap-adjustment col-xs-12 col-sm-6 col-lg-5 no-padding'>
                        <div className='col-xs-12 add-margin-bottom-10 no-padding'>
                          <label>{ this.props.content.create_division.handicap_adjustment_label }</label>
                        </div>
                        <div className='col-xs-12 no-padding'>
                          <div className='col-xs-12 add-margin-bottom-5 no-padding'>
                            <label>
                              <input
                                type='number'
                                className='form-text form-control'
                                name='adjustment_handicap'
                                min={1}
                                max={100}
                                placeholder={100}
                                onChange={ event => this.props.setData([ 'create_division', 'adjustment_handicap' ], event.target.value) }
                              />
                            </label>
                            <span>{ golferLabel.golfers_no_gender }</span>
                          </div>
                          { genderAnswers.map((gender) => (
                              <div className='col-xs-12 add-margin-bottom-5 no-padding' key={`adjustment_handicap_${gender}`}>
                                <label>
                                  <input
                                    type='number'
                                    className='form-text form-control'
                                    name={`adjustment_handicap_${gender}`}
                                    min={1}
                                    max={100}
                                    placeholder={100}
                                    onChange={ event => this.props.setData([ 'create_division', 'gender_adjustment_handicap', gender ], event.target.value) }
                                  />
                                </label>
                                <span>{ `% ${gender} gender` }</span>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
                { criteria.selected.includes('by_age') &&
                  <div className='col-xs-12 no-padding'>
                    <div className='btsp_horizontal_dotted_line'/>
                    <div className='date_to_calculate_age'>
                      <label>{ internationalize('divisions.index.age_gender.date_to_calculate_age') }</label>
                      <DatePicker
                        customInput={<CalendarCustomInput />}
                        selected={ dateForAge && moment.unix(dateForAge).toDate() }
                        dateFormat={ dateFormat }
                        onChange={(date) => {
                          date = date ? moment(date).unix() : date
                          this.props.setData([ 'create_division', 'date_for_age' ], date)
                        }}
                      />
                    </div>
                  </div>
                }
                {
                  <div className='col-xs-12 no-padding'>
                    <div className='btsp_horizontal_dotted_line hidden'/>
                    <div className='autofill_area hidden'>
                      <div>
                        <label><b>{ internationalize('divisions.index.by_multiple_criteria.autofill_divisions') }</b></label>
                      </div>
                      {
                        autofillOptions.map((option) =>
                          <label key={`autofill_${option.value}`} className={`chip ${option.enabled ? '' : 'disabled '}${option.value === autofill ? 'chip-checked' : ''}`} htmlFor={`autofill_${option.value}`}>
                            <input
                              id={`autofill_${option.value}`}
                              className='no-radio'
                              type='radio'
                              name={`autofill_${option.value}`}
                              value={option.value}
                              onChange={ event => option.enabled && this.props.setData([ 'create_division', 'autofill_options', 'selected' ], event.target.value) }
                              checked={autofill === option.value}
                              disabled={!option.enabled}
                            />
                            <span>{option.label}</span>
                          </label>
                        )
                      }
                    </div>
                    <div className='btsp_horizontal_dotted_line'/>
                    <MultipleCriteriaTable
                      criteria={criteria}
                      golferLabel={golferLabel}
                      defaultTee={defaultTee}
                      holeType={holeType}
                      adjustmentHandicap={this.props.content.create_division.adjustment_handicap}
                      genderAdjustmentHandicap={this.props.content.create_division.gender_adjustment_handicap}
                      dateForAge={dateForAge}
                      divisions={multipleCriteriaDivisions}
                      customFields={customFields}
                      customFieldAnswers={customFieldAnswers}
                      modalOpened={modalOpened}
                      closeModal={this.props.closeModal}
                      setData={this.props.setData}
                      updateDivisionRow={this.props.updateDivisionRow}
                      getMatchingMembers={this.props.getMatchingMembers}
                      leagueMembersCount={availableMembersCount}
                    />
                  </div>
                }
              </>
            }
          </div>
        }
      </div>
    )
  }
}

class EventSetupDivisions extends Component {
  constructor(props){
    super(props)
  }

  render() {
    const { title, dataChanged, saveInProgress, links, addingDivision } = this.props.content

    const errors = Object.values(this.props.content.create_division.errors || {}).filter(x => x)

    return (
      <div className='widget-content-default widget-event-setup-divisions'>
        <div className='title'>
          { title }

          {
            dataChanged &&
              (() => {
                const saveButton = (
                  <a
                    onClick={saveInProgress || errors.length > 0 ? undefined : this.props.save}
                    className='btn btn-primary widget-white-title-button'
                    disabled={errors.length > 0}
                  >
                    { saveInProgress ? internationalize('dashboard_plus.widgets.saving') : links.save.name }
                  </a>
                )

                return errors.length > 0 ? <GlgTooltip tooltip={errors.join('\n')}>{saveButton}</GlgTooltip> : saveButton
              })()
          }
          {
            addingDivision &&
              <a
                onClick={ () => {
                  this.props.setData([ 'addingDivision' ], false)
                  this.props.setData([ 'dataChanged' ], false)
                }}
                className='btn btn-primary widget-white-title-button'
              >
                { internationalize('buttons.cancel') }
              </a>
          }
        </div>

        <div className='content flex-list-layout'>
          <ul>
            {
              addingDivision ?
                <CreateDivision {...this.props} />
                :
                <DivisionsOverview {...this.props} />
            }
          </ul>
        </div>
      </div>
    )
  }
}

EventSetupDivisions.propTypes = {
  content: PropTypes.object,
  setData: PropTypes.func,
  save: PropTypes.func,
  setError: PropTypes.func,
  closeModal: PropTypes.func,
}
DivisionsOverview.propTypes = EventSetupDivisions.propTypes
CreateDivision.propTypes = EventSetupDivisions.propTypes
GolfersDivisionsCount.propTypes = EventSetupDivisions.propTypes

EventSetupDivisions.defaultProps = {
  content: {
    title: 'EVENT DIVISIONS',
    data: {},
  },
}

export default EventSetupDivisions
